import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const fetchSuggestedActions = createAsyncThunk('fetchSuggestedActions', async (_, { rejectWithValue }) => {
  try {
    const { data, status } = await api.get('/actions/suggested');
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch suggested actions'));
  }
});

export const suggestedActions = createSlice({
  name: 'suggestedActions',
  initialState: {
    data: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuggestedActions.fulfilled, (state, action) => {
        state.data = action.payload.data;
      });
  }
});

export const getSuggestedActions = (state) => state.suggestedActions.data;

export { fetchSuggestedActions };

export default suggestedActions.reducer;
